function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './CarouselProvider.css';
import React, { useEffect, useState } from 'react';
import Carousel from 'react-multi-carousel';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import 'react-multi-carousel/lib/styles.css';
import { canUseDOM, get, getGlobalDictionaryTerm } from '../../../utils';
import { ReactComponent as RightCarouselArrow } from "../../../resources/icons/RightCarouselArrow.svg";
import { ReactComponent as LeftCarouselArrow } from "../../../resources/icons/LeftCarouselArrow.svg";
const CarouselProvider = _ref => {
  let {
    moduleRef,
    children,
    getCurrentActiveItem,
    activeItemIndex,
    isSwipeableBeforeChange = false,
    handleCustomAfterChange
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const nextArrowLabel = getGlobalDictionaryTerm(sitecoreContext, 'nextArrowLabel') || 'Next slide';
  const prevArrowLabel = getGlobalDictionaryTerm(sitecoreContext, 'prevArrowLabel') || 'Previous slide';
  let [swipeable, setSwipeable] = useState(true);
  let [isMobile, setIsMobile] = useState(() => canUseDOM ? window.matchMedia(`(max-width: 768px)`).matches : false);
  const carouselRef = React.useRef(null);
  const totalCarouselItems = React.useRef(0);
  const deviceType = '';
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary') || 'var(--main-color)';
  const handleDrag = e => {
    e.preventDefault();
  };
  React.useEffect(() => {
    const container = get(carouselRef, 'current.containerRef.current');
    const slidesList = get(carouselRef, 'current.listRef.current.children');
    if (container) {
      if (Array.from(slidesList)) {
        Array.from(slidesList).forEach(elem => {
          elem.addEventListener('dragstart', e => {
            e.preventDefault();
            e.target.addEventListener('click', handleDrag);
            const handleMouseUp = () => {
              document.removeEventListener('mouseup', handleMouseUp);
              setTimeout(() => {
                e.target.removeEventListener('click', handleDrag);
              }, 500);
            };
            document.addEventListener('mouseup', handleMouseUp);
          });
        });
      }
      ;
      container.addEventListener('touchstart', touchStart);
      container.addEventListener('touchmove', preventTouch, {
        passive: false
      });
    }
    return () => {
      // if (carouselRef.current.containerRef.current) {
      //   carouselRef.current.containerRef.current.removeEventListener("touchstart", touchStart);
      //   carouselRef.current.containerRef.current.removeEventListener("touchmove", preventTouch, {
      //     passive: false
      //   });
      // }
    };
  }, [carouselRef]);
  React.useEffect(() => {
    if (typeof activeItemIndex !== 'undefined' && activeItemIndex != -1) {
      moveToSlide(activeItemIndex); // TODO why this code don`t work second time????
    }
  }, [activeItemIndex]);
  const [state, setState] = React.useState({
    domLoaded: false,
    currentSlide: 0,
    totalItems: 0,
    slidesToShow: 0,
    dotsTotal: 0,
    carouselRef: carouselRef,
    deviceType: deviceType
  });
  useEffect(() => {
    if (canUseDOM) {
      window.addEventListener('resize', () => {
        setIsMobile(window.matchMedia(`(max-width: 768px)`).matches);
      });
    }
    return () => {
      if (canUseDOM) {
        window.addEventListener('resize', () => {
          setIsMobile(window.matchMedia(`(max-width: 768px)`).matches);
        });
      }
    };
  }, []);
  const handleBeforeChange = React.useCallback((nextSlide, data, swipeAnalytics) => {
    //const carousalContainerRef = get(carouselRef, 'current.containerRef.current');
    const isNext = nextSlide > data.currentSlide;
    const {
      currentSlide,
      totalItems,
      deviceType
    } = state;
    const nextIndex = isNext ? currentSlide + 1 < totalItems && currentSlide + 1 || 0 : currentSlide ? currentSlide - 1 : totalItems - 1;
    setState(_objectSpread(_objectSpread({}, state), {}, {
      currentSlide: nextIndex
    }));
    stopVideos();
    if (getCurrentActiveItem) {
      getCurrentActiveItem(nextSlide);
    }
    if ((deviceType == 'mobile' || deviceType == 'tablet') && swipeAnalytics) {
      swipeAnalytics(isNext);
    }
  }, [state]);
  const handleAfterChange = React.useCallback(_ref2 => {
    let {
      currentSlide
    } = _ref2;
    const slidesList = get(carouselRef, 'current.listRef.current.children');
    if (moduleRef && moduleRef.current) {
      moduleRef.current.focus();
    }
  }, [state]);
  const handleCarouselNext = () => {
    carouselRef.current.next();
  };
  const stopVideos = () => {
    const carousalContainerRef = get(carouselRef, 'current.containerRef.current');
    if (carousalContainerRef) {
      /*
        finding all the iframe and resting the source so the video will be stopped after slide changed
        */

      const htmlItems = carousalContainerRef.querySelectorAll('.react-multi-carousel-item');
      for (let index = 0; index < htmlItems.length; index++) {
        const item = htmlItems[index];
        if (item.classList.contains('react-multi-carousel-item--active')) {
          const iframe = item.querySelector('iframe');
          const video = item.querySelector('video');
          if (iframe !== null) {
            let currentSrc = iframe.getAttribute('src');
            currentSrc = currentSrc.replace('autoplay=1&', '');
            iframe.setAttribute('src', currentSrc);
          }
          if (video !== null) {
            video.pause();
          }
        }
      }
    }
  };
  const HandleCarouselDomLoaded = _ref3 => {
    let {
      carouselState
    } = _ref3;
    React.useEffect(() => {
      const {
        domLoaded,
        currentSlide,
        slidesToShow,
        totalItems,
        deviceType
      } = carouselState;
      totalCarouselItems.current = totalItems;
      if (domLoaded) {
        const dotsTotal = Math.ceil(totalItems - slidesToShow + 1);
        setState({
          domLoaded,
          currentSlide,
          slidesToShow,
          totalItems,
          dotsTotal,
          carouselRef,
          deviceType
        });
      }
    }, [carouselState]);
    return null;
  };
  const HandleItemsChange = _ref4 => {
    let {
      carouselState
    } = _ref4;
    React.useEffect(() => {
      let {
        currentSlide,
        slidesToShow,
        totalItems,
        deviceType
      } = carouselState;
      if (totalItems !== state.totalItems || currentSlide !== state.currentSlide || deviceType != state.deviceType) {
        const dotsTotal = Math.ceil(totalItems - slidesToShow + 1);
        if (currentSlide > 0 && dotsTotal === 1) {
          carouselRef.current.goToSlide(0);
        }
        setState(_objectSpread(_objectSpread({}, state), {}, {
          totalItems,
          currentSlide,
          dotsTotal,
          deviceType
        }));
      }
    }, [carouselState]);
    return null;
  };
  let firstClientX, clientX;
  const preventTouch = e => {
    const minValue = 5; // threshold
    clientX = e.touches[0].clientX - firstClientX;

    // Vertical scrolling does not work when you start swiping horizontally.
    if (Math.abs(clientX) > minValue) {
      e.preventDefault();
      e.returnValue = false;
      return false;
    }
  };
  const touchStart = e => {
    firstClientX = e.touches[0].clientX;
  };
  const renderCarousel = (items, config, swipeAnalytics) => {
    return /*#__PURE__*/React.createElement(Carousel, _extends({
      slidesToSlide: activeItemIndex || 1 // TODO rewrite logic activeItemIndex is can`t be slidesToSlide
      ,

      className: `${Main} ${rtl ? rtlCarousel : ''}`,
      ssr: true // means to render carousel on server-side.
      ,

      deviceType: isMobile ? 'mobile' : 'desktop' // Only pass this when use for server-side rendering
      ,

      arrows: false,
      minimumTouchDrag: isMobile ? 5 : 100,
      additionalTransfrom: 1,
      ref: carouselRef,
      transitionDuration: isMobile ? 1 : 100,
      swipeable: isMobile ? swipeable : true,
      beforeChange: (nextSlide, data) => {
        setSwipeable(isSwipeableBeforeChange);
        handleBeforeChange(nextSlide, data, swipeAnalytics);
      },
      afterChange: (e, data) => {
        setSwipeable(true);
        handleAfterChange(data);
        if (handleCustomAfterChange) {
          handleCustomAfterChange(data);
        }
      },
      customButtonGroup: !state.domLoaded ? /*#__PURE__*/React.createElement(HandleCarouselDomLoaded, null) : /*#__PURE__*/React.createElement(HandleItemsChange, null),
      rtl: rtl
    }, config), items);
  };
  const renderDayOverview = items => {
    if (!state.dotsTotal || state.dotsTotal <= 1) return null;
    const middleArrIndex = Math.ceil(items.length / 2);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "offset-xl-1 col-lg-2 col-xl-2"
    }, items.map((item, index) => /*#__PURE__*/React.createElement(React.Fragment, null, index < middleArrIndex && /*#__PURE__*/React.createElement("div", {
      className: `ito__list-item ${state.currentSlide === index ? `ito__list-item--active` : ''}`,
      key: index,
      onClick: () => {
        carouselRef.current.goToSlide(index);
        EventClickTile();
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "body-small ito__list-link"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ito__item-title js-item",
      "data-item": `js-item-` + Number(index + 1)
    }, items[index])))))), /*#__PURE__*/React.createElement("div", {
      className: "offset-xl-1 col-lg-2 col-xl-2"
    }, items.map((item, index) => /*#__PURE__*/React.createElement(React.Fragment, null, index >= middleArrIndex && /*#__PURE__*/React.createElement("div", {
      className: `rigthlist ito__list-item ${state.currentSlide === index ? `ito__list-item--active` : ''}`,
      onClick: () => {
        if (window.screen.width < 480) carouselRef.current.goToSlide(index);
        if (state.dotsTotal < index) carouselRef.current.goToSlide(index - state.dotsTotal);
        EventClickTile();
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "body-small ito__list-link"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ito__item-title js-item",
      "data-item": `js-item-` + Number(index + 1)
    }, items[index]))))))));
  };
  const EventClickTile = () => {
    const listItem = document.querySelectorAll('.js-item');
    listItem.forEach(item => {
      item.addEventListener('click', function () {
        const dataItem = item.getAttribute('data-item');
        const poiActive = document.querySelectorAll('.ito__item-title');
        const poiInnerActive = document.querySelectorAll('.ito__item-info-inner');
        poiActive.forEach(poi => {
          poi.classList.remove('poi--active');
        });
        poiInnerActive.forEach(poi => {
          poi.classList.remove('item-inner--active');
        });
        if (dataItem) {
          const dataItemNumber = dataItem.split('js-item-');
          const poiItem = document.querySelector('.js-item-poi-' + dataItemNumber[1]);
          if (poiItem) {
            poiItem.classList.add('poi--active');
            poiItem.parentElement && poiItem.parentElement.classList.add('item-inner--active');
          }
        }
      });
    });
  };
  const moveToSlide = slideNo => {
    carouselRef.current.goToSlide(slideNo);
  };
  const renderDots = function (clickFunc) {
    let pages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    let isDetSite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let dotsColor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    if (!state.dotsTotal || state.dotsTotal <= 1) return null;
    const showThumbs = !!pages.length;
    const itemProgressSpeed = carouselRef.current.props.autoPlaySpeed;
    const range = totalCarouselItems.current === state.dotsTotal ? 0 : 2;
    const carousalInfinite = state.carouselRef.current.props.infinite;
    return carousalInfinite ? /*#__PURE__*/React.createElement("div", {
      className: `${Main} ${rtl ? rtlCarousel : ''} ${isDetSite ? `${rtl ? ddaRtlDot : ddaDot}` : ''} dot-container ${showThumbs ? 'dot-container--thumbed' : ''}`,
      "data-cy": "carousel-dots",
      style: {
        "--autoplay-interval": `${itemProgressSpeed / 1000}s`,
        "--dots-color": dotsColor ? dotsColor : primaryPageThemeColor
      }
    }, Array.from(Array(totalCarouselItems.current).keys()).map(index => {
      const bulletBackColor = state.currentSlide === index + range ? primaryPageThemeColor : '#c5c5c5';
      const customBulletStyles = showThumbs ? {} : {
        background: bulletBackColor
      };
      return /*#__PURE__*/React.createElement("div", {
        tabIndex: 0,
        key: index + range,
        className: `dot ${state.currentSlide === index + range ? 'dot--active' : ''}`,
        onClick: function () {
          carouselRef.current.goToSlide(index + range);
          if (clickFunc) {
            clickFunc();
          }
        },
        onKeyPress: event => {
          if (event.key === 'Enter' || event.key === 'NumpadEnter') {
            carouselRef.current.goToSlide(index + range);
            if (clickFunc) {
              clickFunc();
            }
          }
        },
        style: customBulletStyles
      }, showThumbs ? /*#__PURE__*/React.createElement("div", {
        className: "thumb-wrapper"
      }, pages[index].thumbUrl === '?&cw=143&ch=80' ? null : /*#__PURE__*/React.createElement("img", {
        src: pages[index].thumbUrl,
        alt: pages[index].thumbAlt,
        className: "image"
      }), /*#__PURE__*/React.createElement("span", {
        className: "text"
      }, pages[index].title)) : null);
    })) : /*#__PURE__*/React.createElement("div", {
      className: `dot-container ${isDetSite ? `${rtl ? ddaRtlDot : ddaDot}` : ''} ${showThumbs ? 'dot-container--thumbed' : ''}`,
      "data-cy": "carousel-dots",
      style: {
        "--autoplay-interval": `${itemProgressSpeed / 1000}s`,
        "--dots-color": dotsColor ? dotsColor : primaryPageThemeColor
      }
    }, Array.from(Array(state.dotsTotal).keys()).map(index => {
      const bulletBackColor = state.currentSlide === index ? primaryPageThemeColor : '#c5c5c5';
      const customBulletStyles = showThumbs ? {} : {
        background: bulletBackColor
      };
      return /*#__PURE__*/React.createElement("div", _extends({
        tabIndex: 0,
        key: index,
        className: `dot ${state.currentSlide === index ? 'dot--active' : ''}`,
        onClick: function () {
          carouselRef.current.goToSlide(index);
          if (clickFunc) {
            clickFunc();
          }
        },
        onKeyPress: event => {
          if (event.key === 'Enter' || event.key === 'NumpadEnter') {
            carouselRef.current.goToSlide(index);
            if (clickFunc) {
              clickFunc();
            }
          }
        }
      }, customBulletStyles), showThumbs ? /*#__PURE__*/React.createElement("div", {
        className: "thumb-wrapper"
      }, pages[index].thumbUrl === '?&cw=143&ch=80' ? null : /*#__PURE__*/React.createElement("img", {
        src: pages[index].thumbUrl,
        alt: pages[index].thumbAlt,
        className: "image"
      }), /*#__PURE__*/React.createElement("span", {
        className: "text"
      }, pages[index].title)) : null);
    }));
  };
  const renderProgressBar = clickFunc => {
    if (!state.dotsTotal || state.dotsTotal <= 1 || totalCarouselItems.current <= 1) return null;
    const carousalInfinite = state.carouselRef.current.props.infinite;
    return carousalInfinite ? /*#__PURE__*/React.createElement("div", {
      className: `${Main} ${rtl ? rtlCarousel : ''} bar-container`
    }, Array.from(Array(totalCarouselItems.current).keys()).map(index => /*#__PURE__*/React.createElement("div", {
      tabIndex: 0,
      key: index,
      className: `bar ${state.currentSlide === index ? 'bar--active' : ''}`,
      style: {
        width: `${100 / state.dotsTotal}%`
      },
      onClick: function () {
        carouselRef.current.goToSlide(index);
        if (clickFunc) {
          clickFunc();
        }
      },
      onKeyPress: event => {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          carouselRef.current.goToSlide(index);
          if (clickFunc) {
            clickFunc();
          }
        }
      }
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "bar-container"
    }, Array.from(Array(state.dotsTotal).keys()).map(index => /*#__PURE__*/React.createElement("div", {
      tabIndex: 0,
      key: index,
      className: `bar ${state.currentSlide === index ? 'bar--active' : ''}`,
      style: {
        width: `${100 / state.dotsTotal}%`
      },
      onClick: function () {
        carouselRef.current.goToSlide(index);
        if (clickFunc) {
          clickFunc();
        }
      },
      onKeyPress: event => {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          carouselRef.current.goToSlide(index);
          if (clickFunc) {
            clickFunc();
          }
        }
      }
    })));
  };

  // TODO enableDisableMode should be always true
  const renderPreviousButton = function (clickFunc) {
    let enableDisableMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let isInteractiveBanner = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let customIcon = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    let isDetSite = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    let isSharedCh = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    if (!state.domLoaded || !state.dotsTotal || state.dotsTotal <= 1) return null;
    return /*#__PURE__*/React.createElement(React.Fragment, null, isInteractiveBanner ? /*#__PURE__*/React.createElement("button", {
      disabled: enableDisableMode ? !state.currentSlide : false,
      className: `${Main} ${rtl ? rtlCarousel : ''} ${CarouselCssArrow} carousel-interactive-btn carousel-interactive-btn--left ${state.currentSlide ? '' : 'carousel-icon--inactive'}`,
      onClick: function () {
        if (clickFunc) {
          clickFunc();
        }
        carouselRef.current.previous();
      },
      onKeyPress: event => {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          if (clickFunc) {
            clickFunc();
          }
          carouselRef.current.previous();
        }
      },
      tabIndex: !state.currentSlide ? -1 : 0,
      "data-cy": "carousel-prev-button",
      style: {
        opacity: !state.currentSlide ? 0.4 : 1,
        transition: 'opacity 0.3s',
        cursor: !state.currentSlide ? 'not-allowed' : 'pointer'
      },
      "aria-label": prevArrowLabel,
      title: prevArrowLabel
    }, /*#__PURE__*/React.createElement("div", {
      className: "testBlock"
    }), isSharedCh ? /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M12.5001 5.5875C12.1751 5.2625 11.6501 5.2625 11.3251 5.5875L7.5001 9.4125C7.1751 9.7375 7.1751 10.2625 7.5001 10.5875L11.3251 14.4125C11.6501 14.7375 12.1751 14.7375 12.5001 14.4125C12.8251 14.0875 12.8251 13.5625 12.5001 13.2375L9.26676 9.99583L12.5001 6.7625C12.8251 6.4375 12.8168 5.90417 12.5001 5.5875Z",
      fill: "#fff"
    })) : /*#__PURE__*/React.createElement("svg", {
      width: "8",
      height: "12",
      viewBox: "0 0 8 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M7.70517 1.41002L6.29517 1.52588e-05L0.295166 6.00002L6.29517 12L7.70517 10.59L3.12517 6.00002L7.70517 1.41002Z",
      fill: "#fff"
    }))) : /*#__PURE__*/React.createElement("button", {
      disabled: enableDisableMode ? !state.currentSlide : false,
      className: `${Main} ${rtl ? rtlCarousel : ''} ${isDetSite ? `${rtl ? ddaRtlArrow : ddaArrow}` : ''} ${CarouselCssArrow} my-icon-white carousel-icon carousel-icon-left ${state.currentSlide ? '' : 'carousel-icon--inactive'}`,
      onClick: function () {
        if (clickFunc) {
          clickFunc();
        }
        carouselRef.current.previous();
      },
      onKeyPress: event => {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          if (clickFunc) {
            clickFunc();
          }
          carouselRef.current.previous();
        }
      },
      tabIndex: !state.currentSlide ? -1 : 0,
      "data-cy": "carousel-prev-button",
      style: {
        opacity: !state.currentSlide ? 0.4 : 1,
        transition: 'opacity 0.3s',
        cursor: !state.currentSlide ? 'not-allowed' : 'pointer'
      },
      "aria-label": prevArrowLabel,
      title: prevArrowLabel
    }, customIcon ? customIcon : /*#__PURE__*/React.createElement(LeftCarouselArrow, {
      className: "icon",
      style: {
        color: `${primaryPageThemeColor}`
      }
    })));
  };

  // TODO enableDisableMode should be always true
  const renderNextButton = function (clickFunc) {
    let enableDisableMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let isInteractiveBanner = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let customIcon = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    let isDetSite = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    let isSharedCh = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    if (!state.domLoaded || !state.dotsTotal || state.dotsTotal <= 1) return null;
    const isLastSlide = state.currentSlide + 1 === state.dotsTotal;
    return /*#__PURE__*/React.createElement(React.Fragment, null, isInteractiveBanner ? /*#__PURE__*/React.createElement("button", {
      disabled: enableDisableMode ? isLastSlide : false,
      className: `${Main} ${rtl ? rtlCarousel : ''} ${CarouselCssArrow} carousel-interactive-btn carousel-interactive-btn--right ${isLastSlide ? 'carousel-icon--inactive' : ''}`,
      onClick: function () {
        if (clickFunc) {
          clickFunc();
        }
        carouselRef.current.next();
        if (typeof window !== 'undefined') {
          window.scrollBy(0, 1);
          window.scrollBy(0, -1);
        }
      },
      onKeyPress: event => {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          if (clickFunc) {
            clickFunc();
          }
          carouselRef.current.next();
        }
      },
      "data-cy": "carousel-next-button",
      tabIndex: isLastSlide ? -1 : 0,
      style: {
        opacity: isLastSlide ? 0.4 : 1,
        transition: 'opacity 0.3s',
        cursor: isLastSlide ? 'not-allowed' : 'pointer',
        userSelect: 'none'
      },
      "aria-label": nextArrowLabel,
      title: nextArrowLabel
    }, isSharedCh ? /*#__PURE__*/React.createElement("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M7.5001 5.59221C7.1751 5.91721 7.1751 6.44221 7.5001 6.76721L10.7334 10.0005L7.5001 13.2339C7.1751 13.5589 7.1751 14.0839 7.5001 14.4089C7.8251 14.7339 8.3501 14.7339 8.6751 14.4089L12.5001 10.5839C12.8251 10.2589 12.8251 9.73388 12.5001 9.40888L8.6751 5.58388C8.35843 5.26721 7.8251 5.26721 7.5001 5.59221Z",
      fill: "#fff"
    })) : /*#__PURE__*/React.createElement("svg", {
      width: "8",
      height: "12",
      viewBox: "0 0 8 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M1.70517 1.52588e-05L0.295166 1.41002L4.87517 6.00002L0.295166 10.59L1.70517 12L7.70517 6.00002L1.70517 1.52588e-05Z",
      fill: "white"
    }))) : /*#__PURE__*/React.createElement("button", {
      disabled: enableDisableMode ? isLastSlide : false,
      className: `${Main} ${rtl ? rtlCarousel : ''} ${isDetSite ? `${rtl ? ddaRtlArrow : ddaArrow}` : ''} ${CarouselCssArrow} my-icon-white carousel-icon carousel-icon-right ${isLastSlide ? 'carousel-icon--inactive' : ''}`,
      onClick: function () {
        if (clickFunc) {
          clickFunc();
        }
        carouselRef.current.next();
        if (typeof window !== 'undefined') {
          window.scrollBy(0, 1);
          window.scrollBy(0, -1);
        }
      },
      onKeyPress: event => {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          if (clickFunc) {
            clickFunc();
          }
          carouselRef.current.next();
        }
      },
      "data-cy": "carousel-next-button",
      tabIndex: isLastSlide ? -1 : 0,
      style: {
        opacity: isLastSlide ? 0.4 : 1,
        transition: 'opacity 0.3s',
        cursor: isLastSlide ? 'not-allowed' : 'pointer',
        userSelect: 'none'
      },
      "aria-label": nextArrowLabel,
      title: nextArrowLabel
    }, customIcon ? customIcon : /*#__PURE__*/React.createElement(RightCarouselArrow, {
      className: "icon",
      style: {
        color: `${primaryPageThemeColor}`
      }
    })));
  };
  return children({
    renderCarousel,
    state,
    renderDots,
    renderProgressBar,
    renderPreviousButton,
    renderNextButton,
    renderDayOverview,
    moveToSlide
  });
};
const CarouselCssArrow = "c17l4y6v";
const ddaArrow = "d52ytox";
const ddaRtlArrow = "d1pt7db2";
const ddaDot = "d65ssm0";
const ddaRtlDot = "dotv37";
const Main = "mgvugh2";
const rtlCarousel = "r1kr2t5n";
export default CarouselProvider;